<template>
  <tr>
    <td><p data-toggle="tooltip" data-placement="top" :title="notification.description" class="text-left">{{ notification.name }}</p></td>
    <td>{{ notification.type }}</td>
    <td>{{ notification.labelId }}</td>
    <td><p v-html="notification.labelText"></p></td>
    <td>
      <p v-for="rule in notification.rules" :key="rule" class="text-left">{{ rule }}</p>
    </td>
    <td class="text-center">
      <span v-if="notification.enabled === '1'" >Si</span>
      <span v-else >No</span>
    </td>
    <td>
      <router-link :to="editUrl">
        <span data-toggle="tooltip" data-placement="top" title="Editar notificación"><img src="../assets/pencil.svg" alt="Modificar notificación"></span>
      </router-link>
    </td>
    <td class="text-center">
      <span class="deleteIcon" data-toggle="tooltip" data-placement="top" title="Eliminar notificación" @click="confirmDeleteNotification(notification.id)"><img src="../assets/trashcan.svg" alt="Eliminar notificación"></span>
    </td>
  </tr>
</template>

<script>
import axios from 'axios';
import bootbox from 'bootbox';

export default {
    name: 'notifications-table-row',
    props: ['notification'],
    computed : {
        editUrl: function () {
            return "/editNotification/" + this.notification.id;
        }
    },
    methods : {
        confirmDeleteNotification (notificationId) {
            let that = this;
            console.log('here')
            bootbox.confirm("Confirmar el borrado de la notificación?", function(result){
                if (result) {
                  that.deleteNotification (notificationId);
                }
            })
        },
        deleteNotification (notificationId) {
            axios
                .delete('https://res.hotelkey.com/reservas/mvc.php/product_decision_scr_notifications_api_rest/Notification/index', { data: {id : notificationId} })
                .then(response => {
                    if (response.data.result) {
                      this.emitSuccess();
                    } else {
                      this.emitError();
                    }
                }).catch(error => {
                    this.emitError(error);
                })
        },
        emitError () {
            this.$emit('error', "Se ha producido un error al eliminar la notificación.");
        },
        emitSuccess () {
            this.$emit('success', "Se ha eliminado la notificación correctamente.");
        }
    }
}
</script>

<style scoped>
.deleteIcon {
  cursor: pointer;
}
</style>
